import styled from 'styled-components';
import sizes from 'styles/sizes';
import { BrandCode } from 'types';

export const CruiseCardPriceDisclosureBase = styled.p`
  display: inline-block;
  ${({ theme }) => ({
    [BrandCode.Celebrity]: `
      align-self: center;
      text-align: center;

      @media (min-width: ${sizes.media.mediumMaxWidth}px) {
        align-self: flex-start;
        text-align: left;
        width: 100%;
      }
    `,
    [BrandCode.RoyalCaribbean]: `
      align-self: center;
      text-align: center;
      width: 60%;

      @media (min-width: ${sizes.media.tabletPortrait}px) {
        align-self: flex-start;
        text-align: left;
        width: 100%;
      }
    `,
  })[theme.brandCode]}
`;

export const CruiseCardPriceDisclosureLabel = styled.span`
  font-size: 10px;
  letter-spacing: -0.2px;

  ${({ theme }) => ({
    [BrandCode.Celebrity]: `
      color: ${theme.palette.text.secondary};
      display: block;
      line-height: 15px;

      @media (min-width: ${sizes.media.tabletPortrait}px) {
        display: inline;

        &:last-of-type {
          margin-left: 3px;
        }
      }

      @media (min-width: ${sizes.media.tabletLandscape}px) {
        display: block;
      }

      @media (min-width: ${sizes.media.mediumMaxWidth}px) {
        display: inline;

        &:last-of-type {
          margin-left: 3px;
        }
      }
    `,
    [BrandCode.RoyalCaribbean]: `
      color: ${theme.palette.grey[800]};
      display: inline;
      line-height: 12px;

      &:last-of-type {
        margin-left: 3px;
      }
    `,
  })[theme.brandCode]}
`;